import React from "react";
import { Button } from "@otp/ui";
import { Map, List } from "@otp/icons";
import { useTranslation } from "react-i18next";

export enum ViewType {
  Map = "map",
  Table = "table",
}

export const ViewSwitcher = ({
  onChange,
  selectedViewType,
}: {
  selectedViewType: ViewType;
  onChange: (type: ViewType) => void;
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex justify-end mb-4">
      <Button
        variant={selectedViewType === ViewType.Table ? "contained" : "outlined"}
        size="small"
        onClick={() => onChange(ViewType.Table)}
        className="mr-2"
      >
        <List className="mr-1" />
        {t("manage-restaurants.view-type.list")}
      </Button>
      <Button
        variant={selectedViewType === ViewType.Map ? "contained" : "outlined"}
        size="small"
        onClick={() => onChange(ViewType.Map)}
      >
        <Map className="mr-1" />
        {t("manage-restaurants.view-type.map")}
      </Button>
    </div>
  );
};
